import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./BankNoc.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

function BankNocForm() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    vehicleNumber: "",
    phoneNumber: "",
    email: "",
    pincode: "",
  });
  const [files, setFiles] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value.toUpperCase() });
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    const vehicle_id = localStorage.getItem("vehicle_id");

    if (!token) {
      setError("Authentication token missing. Please log in again.");
      return;
    }
    if (!vehicle_id) {
      setError("Vehicle ID missing. Please select a vehicle.");
      return;
    }
    if (files.length === 0) {
      setError("Please upload at least one document.");
      return;
    }

    const headers = new Headers();
    headers.append("Authorization", `Bearer ${token}`);

    const form = new FormData();
    form.append("service_type", "BankNOC");
    form.append("vehicle_id", vehicle_id);
    form.append(
      "additional_info",
      JSON.stringify({
        name: formData.name,
        phone_number: formData.phoneNumber,
        email: formData.email,
        pincode: formData.pincode,
      })
    );
    files.forEach((file) => {
      form.append("documents", file);
    });

    try {
      const response = await fetch(
        "https://api.rtoxpert.com/api/service-requests",
        {
          method: "POST",
          headers,
          body: form,
          redirect: "follow",
        }
      );

      if (response.ok) {
        setShowPopup(true);
        setError(null);
        setTimeout(() => {
          setShowPopup(false);
          navigate("/profile");
        }, 2000);
      } else {
        const errorText = await response.text();
        setError("Submission failed: " + errorText);
      }
    } catch (err) {
      console.error(err);
      setError("Error occurred: " + err.message);
    }
  };

  return (
    <div style={{ width: "100%", padding: "2rem" }}>
      <h2 className={styles.renewalTitle}>Bank NOC & Form 35</h2>
      <p className={styles.renewalDescription}>
        Finished your car loan? Great! But did you know your car’s RC still
        shows a loan label? Get a Bank NOC (No Objection Certificate) and Form
        35 to officially remove the loan tag from your vehicle’s records.
      </p>

      <div className={styles.renewalContainer}>
        <div className={styles.renewalSection}>
          <h3 className={styles.benefitsTitle}>Benefits</h3>
          <div className={styles.benefitsList}>
            <div className={styles.benefitItem}>
              <div className={styles.checkIcon}>
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <p>Avoid legal and insurance complications by renewing on time.</p>
            </div>
            <div className={styles.benefitItem}>
              <div className={styles.checkIcon}>
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <p>Continued driving privileges.</p>
            </div>
          </div>

          <h3 className={styles.documentsTitle}>Documents Required</h3>
          <p className={styles.agentText}>
            Our agent will call you & request the following documents:
          </p>
          <div className={styles.documentsList}>
            <div className={styles.documentItem}>
              <div className={styles.checkIcon}>
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <p>Aadhar Card/PAN Card</p>
            </div>
            <div className={styles.documentItem}>
              <div className={styles.checkIcon}>
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <p>Old Driving License (DL) Copy</p>
            </div>
            <div className={styles.documentItem}>
              <div className={styles.checkIcon}>
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <p>Passport Size Photo</p>
            </div>
            <div className={styles.documentItem}>
              <div className={styles.checkIcon}>
                <FontAwesomeIcon icon={faCheck} />
              </div>
              <p>Owner Signature on Blank Page</p>
            </div>
          </div>
        </div>

        <div className={styles.contactSection}>
          <h3 className={styles.contactTitle}>Contact Details</h3>
          <p className={styles.alertText}>
            The alerts will be sent on{" "}
            <span className={styles.whatsappText}>WhatsApp</span>
          </p>
          <div className={styles.formFields}>
            <input
              type="text"
              name="name"
              placeholder="Enter Full Name"
              className={styles.formInput}
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="text"
              name="vehicleNumber"
              placeholder="Enter Vehicle Number"
              className={styles.formInput}
              value={formData.vehicleNumber}
              onChange={handleChange}
            />
            <input
              type="tel"
              name="phoneNumber"
              placeholder="Enter Mobile Number"
              className={styles.formInput}
              value={formData.phoneNumber}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Enter Email Address"
              className={styles.formInput}
              value={formData.email}
              onChange={handleChange}
            />
            <input
              type="text"
              name="pincode"
              placeholder="Enter Pincode"
              className={styles.formInput}
              value={formData.pincode}
              onChange={handleChange}
            />
            <div className={styles.fileInputGroup}>
              <label>Upload Documents</label>
              <div className={styles.fileUploadWrapper}>
                <label className={styles.fileUploadLabel}>
                  Choose File(s)
                  <input
                    type="file"
                    className={styles.fileInput}
                    onChange={handleFileChange}
                    multiple
                  />
                </label>
              </div>

              {files.length > 0 && (
                <ul className={styles.uploadedFiles}>
                  {files.map((file, index) => (
                    <li key={index} className={styles.fileItem}>
                      📄 {file.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </div>

      {error && <p className={styles.errorText}>{error}</p>}
      {showPopup && (
        <div className={styles.popup}>
          <p>Submission successful! Redirecting to profile...</p>
        </div>
      )}
      <button className={styles.checkStatusBtn} onClick={handleSubmit}>
        Send Inquiry
      </button>
    </div>
  );
}

export default BankNocForm;